import "./LoginModal.less";

import * as React from "react";

import { IBaseProps } from "lib/data/interfaces";
import { Modal } from "antd";
import { LoginPage } from "components/pages";
import { withRouter, RouteComponentProps } from "react-router";
import { LoginSession } from "lib/data/model";


interface ILoginModalProps extends IBaseProps, RouteComponentProps {
	visible: boolean;
	show(): void;
	hide(): void;
	login(username: string, password: string): Promise<LoginSession | string | undefined>;
	errorMessage?:string;
}

const LoginModalPreRouter = (props: ILoginModalProps) =>
	<Modal footer={null} visible={props.visible} onCancel={props.hide} onOk={props.show}>
		<LoginPage errorMessage={props.errorMessage} login={props.login} modal={true} />
	</Modal>

export const LoginModal = withRouter(LoginModalPreRouter);
